import { Card } from '@sandtech-hub-monorepo/ui-kit';
import { CalendarIcon } from 'lucide-react';
import { formatDate } from '@sandtech-hub-monorepo/ui-kit-site';
import { ApplicationRequirements } from './ApplicationRequirements';
import { ScholarshipNotificationBanner } from './ScholarshipNotificationBanner';
import { Application, Enrollment } from '../types';

interface Props {
  enrollment: Enrollment;
  application?: Application;
}

export const ProgramOverviewCard = ({ enrollment, application }: Props) => {
  const program = enrollment.program;
  const startDate =
    enrollment.plannedCourses[0]?.enrollment?.currentClass?.class.startDate;

  return (
    <Card className="overflow-hidden border-0 shadow-none">
      <div className="flex min-h-[500px] flex-wrap">
        {/* Left Side - Full Height Cover Image */}
        <div className="w-1/3 relative">
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat rounded-xl"
            style={{
              backgroundImage: `url("${program.marketing.thumbnail}")`,
            }}
          >
            {/* Dark overlay for better text readability */}
            <div className="absolute inset-0 bg-black/20 rounded-xl"></div>
          </div>
        </div>
        {/* Right Side Content */}
        <div className="flex-1 flex flex-col p-6">
          {/* Top Right - Title and Description */}
          <div>
            <div className="flex-1">
              <h1 className="text-xl font-semibold text-primary mb-3">
                {program.name}
              </h1>
              <p className="text-sm text-foreground/70 leading-relaxed mb-4">
                {program.description}
              </p>

              {/* Start Date and Duration */}
              <div className="flex items-center gap-4 text-sm text-foreground/60">
                <div className="flex items-center gap-1">
                  <CalendarIcon className="w-4 h-4" />
                  <span>
                    {/* Show start date if it exists, otherwise show duration */}
                    {startDate ? (
                      <>
                        Start Date: {formatDate(startDate)}
                        {program.marketing.programDuration && (
                          <> • {program.marketing.programDuration}</>
                        )}
                      </>
                    ) : (
                      program.marketing.programDuration || 'Duration TBD'
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {application && (
            <ApplicationRequirements
              enrollment={enrollment}
              application={application}
            />
          )}
          <ScholarshipNotificationBanner />
        </div>
      </div>
    </Card>
  );
};
